export default __webpack_public_path__ + "static/media/CSR2.d97c21d7.jpg";